/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Detail_Account_CreatedInputs */

const en_users_detail_account_created = /** @type {(inputs: Users_Detail_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account Created`)
};

const pt_br2_users_detail_account_created = /** @type {(inputs: Users_Detail_Account_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta criada em`)
};

/**
* | output |
* | --- |
* | "Account Created" |
*
* @param {Users_Detail_Account_CreatedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_detail_account_created = /** @type {((inputs?: Users_Detail_Account_CreatedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Detail_Account_CreatedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_detail_account_created(inputs)
	return pt_br2_users_detail_account_created(inputs)
});